'use client'

import { cn } from '@/lib/utils'
import { Typo3Page } from '@/types'
import { Base, Button, Container } from '@/ui/components'
import { BaseProps } from '@/ui/components/types/base'
import { usePathname, useRouter } from 'next/navigation'
import { memo } from 'react'

interface Props extends BaseProps {
  data: Typo3Page
  className?: string
  haveImage?: boolean
}

const Breadcrumbs = ({ data, className, haveImage, ...props }: Props) => {
  const router = useRouter()
  const pathname = usePathname()
  const breadcrumbs = data?.breadcrumbs

  if (
    !breadcrumbs ||
    breadcrumbs.length < 1 ||
    (breadcrumbs.length === 1 && breadcrumbs[0].link === pathname)
  ) {
    return null
  }

  const item =
    breadcrumbs.length > 1
      ? breadcrumbs[breadcrumbs.length - 2]
      : breadcrumbs[0]

  // Check if item.link is the same as pathname without the last part (used in detail pages to go back to the list filtered list page)
  const isSameAsBack = item.link === pathname.split('/').slice(0, -1).join('/')

  return (
    <Base
      as="nav"
      aria-label="Breadcrumb"
      className={cn(className, 'bg-neutral-200', haveImage && 'md:-mt-14')}
      {...props}
    >
      <Container className="px-0!">
        <ol>
          <li>
            <Button
              icon="material-symbols:arrow-back-ios-new"
              iconPosition="left"
              className="px-padding-lg py-md"
              variant="tertiary"
              size="s"
              href={item.link}
              nextLink={false}
              onClick={(e) => {
                if (!item.link || isSameAsBack) {
                  const cameFromSameSite =
                    typeof document !== 'undefined' &&
                    document.referrer !== '' &&
                    new URL(document.referrer).origin === window.location.origin

                  // Only go back when the previous page is within this site,
                  // otherwise fall back to navigating to item.link
                  if (cameFromSameSite || !item.link) {
                    e.preventDefault()
                    router.back()
                  }
                }
              }}
            >
              {item.title}
            </Button>
          </li>
        </ol>
      </Container>
    </Base>
  )
}

export default memo(Breadcrumbs)
